/**
 * Which paths belong to a buyer rather than to staff.
 *
 * This is a pathname list, and it is deliberately NOT the `staticData`
 * route-option pattern the rest of the app uses for route-declared behaviour.
 * The service worker is a separate script with no router and no `useMatches`,
 * so it cannot read a route's `staticData` — a path predicate is the only thing
 * that crosses the worker boundary. Both consumers import this one constant so
 * there is a single list rather than a copy on each side.
 *
 * `/s/:token` is a Selection, `/q/:token` a Quotation (the latter arrives with
 * S3; listing it now costs nothing and is one fewer thing to remember then).
 *
 * What this buys: a buyer's phone must not install the PWA or precache 311
 * products because someone forwarded them a link.
 */
const PUBLIC_PATH_PREFIXES = ['/s/', '/q/'] as const;

export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
}

/**
 * The same list as `RegExp`s, because Workbox's `NavigationRoute` denylist takes
 * patterns rather than a predicate. Derived, not retyped — a second literal here
 * is exactly the drift this module exists to prevent.
 */
export const PUBLIC_PATH_PATTERNS: readonly RegExp[] = PUBLIC_PATH_PREFIXES.map(
  prefix => new RegExp(`^${prefix.replace(/\//g, '\\/')}`)
);
